import { Language } from '../../generic/classes/language';

const availableLanguagesArray = [
    new Language('ENG', 'EN', 'English'),
    new Language('SVE', 'SV', 'Svenska'),
    new Language('DAN', 'DA', 'Dansk'),
    new Language('CZE', 'CS', 'Česky'),
    new Language('DEU', 'DE', 'Deutsch'),
    new Language('FIN', 'FI', 'Suomalainen'),
    new Language('FRA', 'FR', 'Français'),
    new Language('NLD', 'NL', 'Nederlands'),
    new Language('NOR', 'NB', 'Norsk'),
    new Language('POL', 'PL', 'Polski'),
    new Language('RUS', 'RUS', 'Pусский'),
    new Language('SK', 'SK', 'Slovenský'),
];

export { availableLanguagesArray };
